import React, { useEffect, useState } from 'react';
import styled, { keyframes, css } from 'styled-components';

// Spring-in animation for new reactions
const springIn = keyframes`
  0% {
    opacity: 0;
    transform: scale(0) rotate(0deg);
  }
  50% {
    opacity: 1;
    transform: scale(1.3) rotate(10deg);
  }
  100% {
    opacity: 1;
    transform: scale(1) rotate(var(--rotation));
  }
`;

// Bounce-out animation for removed reactions  
const bounceOut = keyframes`
  0% {
    opacity: 1;
    transform: scale(1) rotate(var(--rotation));
  }
  100% {
    opacity: 0;
    transform: scale(0) rotate(calc(var(--rotation) - 20deg));
  }
`;

const EmojiWrapper = styled.span`
  position: absolute;
  font-size: 16px;
  line-height: 1;
  --rotation: ${props => props.$rotation}deg;
  z-index: ${props => props.$zIndex};
  left: ${props => props.$leftOffset}px;
  user-select: none;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), 
              left 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              filter 0.2s ease;
  
  ${props => props.$animate && css`
    animation: ${springIn} 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
  `}
  
  ${props => props.$removing && css`
    animation: ${bounceOut} 0.3s cubic-bezier(0.55, 0.055, 0.675, 0.19) forwards;
  `}
  
  ${props => !props.$animate && !props.$removing && css`
    transform: rotate(var(--rotation)) scale(1);
  `}
  
  &:hover {
    transform: rotate(var(--rotation)) scale(1.25) !important;
    z-index: 100;
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
  }
`;

const AnimatedReaction = ({ 
  emoji, 
  rotation, 
  leftOffset, 
  zIndex, 
  isRemoving = false,
  uniqueKey 
}) => {
  const [shouldAnimate, setShouldAnimate] = useState(true);

  useEffect(() => {
    // Always animate on mount
    setShouldAnimate(true);
    
    // Remove animation class after animation completes
    const timer = setTimeout(() => {
      setShouldAnimate(false);
    }, 600);

    return () => clearTimeout(timer);
  }, [uniqueKey]); // Re-run when uniqueKey changes

  return (
    <EmojiWrapper
      $rotation={rotation}
      $leftOffset={leftOffset}
      $zIndex={zIndex}
      $animate={shouldAnimate && !isRemoving}
      $removing={isRemoving}
    >
      {emoji}
    </EmojiWrapper>
  );
};

export default AnimatedReaction;